module.exports = __webpack_public_path__ + "img/racecourse-scottsville-turf-inner-1950.2e6fa19e.svg";